import { TimekeeperService } from "services/TimekeeperService";
const tk = new TimekeeperService();

const gettingPaycodeDistributionId = async (id) => {
    return tk.paycode_distributions.getPaycodeDistributionById(id)
}

export {
    gettingPaycodeDistributionId
}